const TOKEN_QUERY_PARAM = 'tokenOnlyUse',
  CALLBACK_URL_QUERY_PARAM = 'callbackUrl',
  LANGUAGE_QUERY_PARAM = 'language';

export { CALLBACK_URL_QUERY_PARAM, LANGUAGE_QUERY_PARAM, TOKEN_QUERY_PARAM };
